<template>
    <div class="vue-pickup-point-selector">
        <label for="pickup-point-selector" class="visually-hidden">{{ translations.pickupPointSelectorLabel }}</label>

        <select v-model="selectedPickupPointId" @change="handlePickupPointSelection" id="pickup-point-selector" class="w-100">
            <option v-for="pickupPoint in location.pickupPoints" :key="pickupPoint.id" :value="pickupPoint.id">
                {{ pickupPoint.streetName }}, {{ pickupPoint.place.trim()[0].toUpperCase() + pickupPoint.place.trim().slice(1) }}
            </option>
        </select>
    </div>
</template>

<script>
import translations from "../../mixins/translations";
export default {
    name: "PickupPointSelector",

    mixins: [translations],

    props: {
        location: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            pickupPoint: null,
            selectedPickupPointId: null,
        }
    },

    created() {
        this.selectedPickupPointId = this.location.pickupPoints[0].id
    },

    methods: {
        handlePickupPointSelection() {
            this.pickupPoint = this.location.pickupPoints.find(pickupPoint => pickupPoint.id === this.selectedPickupPointId);
            this.$emit('pickup-point', this.pickupPoint);
        },
    },
}
</script>

<style scoped>

</style>
